<template>
  <div class="main-hub-container">
    <div class="inner-hub-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "HubContainer"
  }
</script>

<style lang="scss" scoped>
  .main-hub-container {
    overflow: auto;
    padding-top: 40px;
  }
  .inner-hub-container {
    max-width: 1100px;
    min-height: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    align-content: center;
    overflow: visible;
  }
</style>